// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"dc476ae7","container":"bdadb395","inner":"ead31751"};